export enum VisitCompletionType {
  NotComplete = 1,
  CompletedNormally = 2,
  CompletedwithOverride = 3,
  IssueswithLegalBacker = 4,
  Abandoned = 5,
  Other = 6,
  CompletedviaDI = 7,
  Customerdidnotshowforthisappointment = 8,
  Duplicatevisitandorpet = 9,
  PetunabletoseeDVM = 10,
  Priceforserviceswastoohigh = 11,
  Clientconfusiononhospitalvsvaccinationclinic = 12,
  Petwasreferredout = 13,
  Petwasaggressive = 14,
  Clientchosetodiscontinueservices = 15,
  Petwasnoteligibleforservices = 16,
  Performedservicesunderthewrongpet = 17,
  Petparentnolongerwantsthemedication = 18,
}

export namespace VisitCompletionType {
  export const visitIsAborted = (
    visitCompletionTypeId?: number | undefined,
  ) => {
    return [
      VisitCompletionType.Priceforserviceswastoohigh,
      VisitCompletionType.Clientconfusiononhospitalvsvaccinationclinic,
      VisitCompletionType.Petwasreferredout,
      VisitCompletionType.Petwasaggressive,
      VisitCompletionType.Clientchosetodiscontinueservices,
      VisitCompletionType.Petwasnoteligibleforservices,
      VisitCompletionType.Performedservicesunderthewrongpet,
      VisitCompletionType.Petparentnolongerwantsthemedication,
      VisitCompletionType.Other,
    ].includes(visitCompletionTypeId ?? 0);
  };
}
